import { Injectable } from '@angular/core';
import {Constants} from "../models/constants";
import {UtilsService} from "./utils.service";
import {Config} from "../config";
import {AuthService} from "./auth.service";

@Injectable({
  providedIn: 'root'
})
export class SyncService {

  public remoteDatabase: boolean = true;

  constructor(
    private utils: UtilsService,
    private config: Config,
    private authService: AuthService
  ) {

  }


  public async syncCategory(categoryId: number) {
    //console.log('Syncing category: ' + categoryId);

    let categories = await fetch(this.config.EDOC_CATEGORY_API + categoryId, {
      'headers': this.authService.getToken()
    })
      .then(response => response.json())
      .then(responseJson => {
        return responseJson;
      })
      .catch(err => {
        this.utils.showToast('Error fetching items', 5000, 'danger');
        console.error(err)
      });

    return categories;
  }

  public async syncItems(categoryId: number) {
    //console.log('syncItems', categoryId);

    let items = await fetch(this.config.EDOC_LIST_ITEMS_API + categoryId, {
      'headers': this.authService.getToken()
    })
      .then(response => response.json())
      .then(responseJson => {
        return responseJson;
      })
      .catch(err => {
        this.utils.showToast('Error fetching items', 5000, 'danger');
        console.error(err)
      });

    return items;
  }

  public async deleteEdoc(eDocId: number) {
    let delete_URL = this.config.EDOC_MANAGER_API + eDocId + '/delete';

    let postRequest = await fetch(delete_URL, {
      'method': 'POST',
      'headers': this.authService.getToken(),
      'body': JSON.stringify({
        '_method': 'DELETE'
      })
    })
      .then(response => response.json())
      .then(responseJson => {
        return responseJson;
      }).catch(err => console.error(err));
  }

  public async syncEdoc(eDocId: number) {
    let details_URL = this.config.EDOC_SHOW_ITEM_API + eDocId + '/list';

    // check if edocs_details already exists
    let items = await fetch(details_URL, {
      'headers': this.authService.getToken()
    })
      .then(response => response.json())
      .then(responseJson => {
        return responseJson;
      })
      .catch(err =>  {
        this.utils.showToast('Error fetching items', 5000, 'danger');
        console.error(err)
        return false;
      });

    return items;
  }
}
